import { generatePath, matchPath } from "react-router-dom";

export const loginDestinationRoutes = {
  oauth: {
    root: "oauth",
    authorize: "authorize/:clientId",
    connect: "connect",
  },
  gorgias: { root: "gorgias", connect: "connect" },
} as const;

const oauthAuthorizePattern =
  `/${loginDestinationRoutes.oauth.root}/${loginDestinationRoutes.oauth.authorize}` as const;

export function oauthAuthorizeUrl({ clientId }: { clientId: string }): string {
  return generatePath(oauthAuthorizePattern, {
    clientId: encodeURIComponent(clientId),
  });
}

const oauthConnectPattern =
  `/${loginDestinationRoutes.oauth.root}/${loginDestinationRoutes.oauth.connect}` as const;

/** An OAuth consent page: the public MCP's, or a pre-registered app's connect page. */
export function isOAuthAuthorizePath(pathname: string): boolean {
  return (
    matchPath(oauthAuthorizePattern, pathname) !== null ||
    matchPath(oauthConnectPattern, pathname) !== null
  );
}

export function gorgiasConnectUrl({ account }: { account: string }): string {
  const { root, connect } = loginDestinationRoutes.gorgias;
  return `/${root}/${connect}?${new URLSearchParams({ account })}`;
}
